import React, { JSX } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Resume } from 'types/types';
import { ResumeInfo } from 'components/ui/ResumeInfo';

export function ResumeDetails(props: {
  selectedResume: Resume | null;
  inDialog?: boolean;
}): JSX.Element {
  const { selectedResume, inDialog = false } = props;

  return (
    <Box
      sx={{
        flex: 1,
        overflow: 'auto',
        p: inDialog ? 1.5 : 0.75,
        height: inDialog ? '100%' : 'auto',
      }}
    >
      {selectedResume ? (
        <ResumeInfo
          resume={selectedResume}
          variant="all"
          sx={{
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
            '& .MuiTypography-h6': { fontSize: inDialog ? '1.25rem' : '1.1rem' },
          }}
        />
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: 'text.secondary',
            textAlign: 'center',
            p: 2,
          }}
        >
          <Typography variant="body2">Select a resume to view details</Typography>
        </Box>
      )}
    </Box>
  );
}

export function DesktopResumeDetails(props: { selectedResume: Resume | null }): JSX.Element {
  return (
    <Paper sx={{ width: '50%', display: 'flex', flexDirection: 'column', elevation: 1 }}>
      <Box
        sx={{
          p: 0.75,
          borderBottom: 1,
          borderColor: 'divider',
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h6" sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
          Resume Details
        </Typography>
      </Box>
      <ResumeDetails selectedResume={props.selectedResume} />
    </Paper>
  );
}
